import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import {
  getHomeContents,
  portalHomeQueryKey,
} from "../../services/portalAluno/home/homeService";
import type { ApplicationState } from "../../store";

export { portalHomeQueryKey };

const useHomeContents = () => {
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const idUsuario = auth?.idUsuario;

  return useQuery({
    enabled: Boolean(idUsuario),
    queryKey: portalHomeQueryKey(idUsuario),
    queryFn: () => getHomeContents(),
  });
};

export default useHomeContents;
